import useGetApi from 'src/api/useGetApi';
import { UsageMetricsResponse } from 'src/types/business-intelligence/EmailPOMetrics';

interface DateRangeParams {
  from?: string; // ISO date string (YYYY-MM-DD)
  to?: string; // ISO date string (YYYY-MM-DD), optional - defaults to present
  groupBy?: 'daily' | 'weekly' | 'monthly'; // Time granularity
}

const useEmailPOMetrics = (dateRange?: DateRangeParams) => {
  return useGetApi<UsageMetricsResponse>({
    endpoint: 'analytics/usage',
    queryParameters: dateRange,
    options: {
      refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
      staleTime: 2 * 60 * 1000, // Consider data stale after 2 minutes
    },
  });
};

export default useEmailPOMetrics;
